// Figma "cases" > Lotus, section 55:1843, frames 55:1844 (cover), 55:1882, 55:1909, 55:1935
import type { Case, Img } from "../types"

const own = (n: string, w: number, h: number): Img => {
    const src = `/work/lotus/${n}`
    return { id: src, src, w, h, widths: [...[800, 1600].filter((x) => x < w), w] }
}
const LOTUS = own

export const lotus: Case = {
    name: "Lotus",
    theme: {
        page: "#020206",
        gradient: "linear-gradient(180deg, #020206 0%, #1a1a1a 108.16%)",
        // #1a1a1a sits at 108.16%: the colour at 100% is #181818
        stops: [
            [2, 2, 6, 0],
            [24, 24, 24, 1],
        ],
        fill: "#fff200",
        line: "#fff200",
        tone: "dark",
        title: "#ffffff",
        body: "rgba(255, 255, 255, 0.6)",
    },
    modules: [
        {
            type: "grid",
            columns: [
                {
                    w: 220,
                    cells: [
                        {
                            h: 220,
                            tag: {
                                logo: "/work/lotus/logo.svg",
                                logoBox: [20, 22, 112, 25],
                                text: "LOTUS\nCAR BRAND\nFOUNDED 1952\n\nSHOWROOM EXPERIENCE",
                                ink: "#000000",
                            },
                        },
                        { h: 626 },
                    ],
                },
                { w: 720, cells: [{ h: 846, image: LOTUS("1-1", 1440, 1692) }] },
                {
                    w: 611,
                    cells: [
                        { h: 443, phone: false, image: { id: "/work/lotus/c-cover", src: "/work/lotus/c-cover", w: 1222, h: 886, widths: [800, 1222] }, clip: { src: "/work/lotus/c-cover" } }, // video: node 55:1869, showroom UI: silver Eletre front wheel on yellow, "YOUR ELETRE S" price box
                        {
                            h: 400,
                            w: 443,
                            card: {
                                title: "The virtual showroom of tomorrow",
                                body: "A truly different way to get to grips with the new Lotus Eletre. A guided experience with a human touch that makes you feel like you are at the showroom. Designed together with Marten Kuipers, Franklin Schamhart, Leonardo Pantuso, among others.",
                            },
                        },
                    ],
                },
            ],
        },
        {
            type: "grid",
            columns: [
                { w: 446, cells: [{ h: 652, image: LOTUS("2-1", 892, 1304) }, { h: 191 }] },
                { w: 1107, cells: [{ h: 846, keep: true, image: { id: "/work/lotus/c-entry", src: "/work/lotus/c-entry", w: 1920, h: 1468, widths: [800, 1920] }, clip: { src: "/work/lotus/c-entry" } }] }, // video: node 55:1907, showroom UI: three grey Eletres in a white hall, "YOUR ELETRE S" price box
            ],
        },
        {
            // one video, 1501 wide, centred
            type: "grid",
            phoneCenter: true,
            columns: [
                { w: 25, cells: [{ h: 846 }] },
                { w: 1501, cells: [{ h: 846, fit: true, keep: 16 / 9, image: { id: "/work/lotus/c-lidar", src: "/work/lotus/c-lidar", w: 1920, h: 1080, widths: [800, 1600, 1920] }, clip: { src: "/work/lotus/c-lidar" } }] }, // video: node 55:1934, showroom UI: Eletre from above-rear in a dark room, presenter inset "HEAD OF TECHNOLOGY"
                { w: 25, cells: [{ h: 846 }] },
            ],
        },
        {
            type: "grid",
            phoneCenter: true,
            columns: [
                {
                    w: 888,
                    cells: [
                        { h: 331, image: LOTUS("4-1", 1776, 662), phone: false },
                        { h: 512, keep: 16 / 9, image: { id: "/work/lotus/c-colour", src: "/work/lotus/c-colour", w: 1776, h: 1024, widths: [800, 1776] }, clip: { src: "/work/lotus/c-colour" } }, // video: node 55:1961, configurator UI: yellow Eletre side view, paint swatches, "EXTERIOR PAINT OPTIONS"
                    ],
                },
                {
                    w: 666,
                    cells: [
                        { h: 512, image: { id: "/work/lotus/c-roof", src: "/work/lotus/c-roof", w: 1332, h: 1024, widths: [800, 1332] }, clip: { src: "/work/lotus/c-roof" } }, // video: node 55:1960, showroom UI: interior with glass roof, "STANDARD ROOF / GLASS ROOF"
                        { h: 331 },
                    ],
                },
            ],
        },
    ],
}
